import axios from '@/utils/axios'
import { propOr, path } from 'ramda'
const SET_CURRENT_PAYMENT_CONTRACT = 'set_current_payment_contract'
// initial state
const setInitialState = () => ({
    // Data of the current payment/contract
    currentPaymentId: null,
    currentPayment: {},
})
const state = setInitialState()

const getters = {
    currentPayment: propOr({}, 'currentPayment'),
    currentPlanDetails: path(['currentPayment', 'plan_details']),
    currentContract: path(['currentPayment', 'contract'])
}

const actions = {
    getCurrentPaymentContract({commit}, { organizationId = null } = {}) {
        return axios.get(`/v1/checkouts/${organizationId}/payments`)
        .then(response => commit(SET_CURRENT_PAYMENT_CONTRACT, response.data))
    },
}

const mutations = {
    [SET_CURRENT_PAYMENT_CONTRACT](state, currentPayment ) {
        state.currentPayment = { ...currentPayment }
    },
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }
